import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminLogin from "./pages/AdminLogin";
import GetStarted from "./pages/GetStarted";
import Verify from "./pages/Verify";
import Dashboard from "./pages/Dashboard";
import AdminCost from "./pages/AdminCost";
import AdminLeads from "./pages/AdminLeads";
import ProspectScan from "./pages/ProspectScan";
import AdminLeadDetail from "./pages/AdminLeadDetail";
import ManageBilling from "./pages/ManageBilling";
import ReportHistory from "./pages/ReportHistory";
import Milestones from "./pages/Milestones";
import PublicReport from "./pages/PublicReport";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { LoadingScreen } from "./components/LoadingScreen";

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Landing scrollTo="pricing" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/get-started" element={<ProtectedRoute><GetStarted /></ProtectedRoute>} />
            <Route path="/verify/:token" element={<Verify />} />
            <Route path="/r/:token" element={<PublicReport />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><ReportHistory /></ProtectedRoute>} />
            <Route path="/milestones" element={<ProtectedRoute><Milestones /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute><ManageBilling /></ProtectedRoute>} />
            <Route path="/admin/cost" element={<ProtectedRoute><AdminCost /></ProtectedRoute>} />
            <Route path="/admin/leads" element={<ProtectedRoute><AdminLeads /></ProtectedRoute>} />
            <Route path="/admin/leads/:id" element={<ProtectedRoute><AdminLeadDetail /></ProtectedRoute>} />
            <Route path="/admin/prospect-scan" element={<ProtectedRoute><ProspectScan /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
